const answerKeyByLang = {
    en: 'english_answer',
    hi: 'hindi_answer',
    gu: 'gujarati_answer',
}

const solutionKeyByLang = {
    en: 'english_solution',
    hi: 'hindi_solution',
    gu: 'gujarati_solution',
}

export { answerKeyByLang, solutionKeyByLang }
